import { cnUtils } from '@cainiaofe/cn-ui';
import { useEffect, useState } from 'react';
import { dataOriginRequest, dataOriginStatic } from '@/lowcode/common/util/const';
import { getLowCodeCoreUtil, isArrayNotEmpty } from '@/lowcode/common/util/util';

export const CnFilterOnSearch = 'L2_CnFilter_onSearch';
// 筛选栏默认值准备完成的回调
export const CnFilterDefaultValueFinished = 'L2_CnFilterDefaultValueFinished';

export function emitEvent(eventName: string, ...args: any[]) {
  const events = cnUtils?.events;
  if (events && eventName) {
    events?.emit(eventName, ...args);
  }
}

export function onEvent(eventName: string, func: (...args: any[]) => void) {
  const events = cnUtils?.events;
  if (events && eventName && typeof func === 'function') {
    return events?.on(eventName, func);
  }
}

export function offEvent(eventName: string, func: (...args: any[]) => void) {
  const events = cnUtils?.events;
  if (events && eventName) {
    return events?.off(eventName, func);
  }
}

export default function useFilterSearchListener(options: any) {
  const { _bindFilter = [], sendRequest, _context } = options || {};
  const [requestFinishedFilter, setRequestFinishedFilter] = useState(() => {
    const needRequestFilterList: any[] = [];
    _bindFilter?.forEach?.((item: string) => {
      const filterDom = _context?.$(item);
      const isCnStatisticCard = filterDom?.props?.isCnStatisticCard;
      const isFilterCondition = filterDom?.props?.isFilterCondition;
      if (isCnStatisticCard || isFilterCondition) {
        needRequestFilterList.push(item);
      } else {
        const dataOrigin = filterDom?.props?.defaultParams?.dataOrigin;
        if (dataOrigin === dataOriginRequest) {
          needRequestFilterList.push(item);
        } else if (dataOrigin === dataOriginStatic) {
          const tempResult = getLowCodeCoreUtil('util.calculateWaitComponentList')?.(
            filterDom?.props?.config,
            filterDom?.props?.defaultParams,
          );
          if (isArrayNotEmpty(tempResult?.waitComponentList)) {
            needRequestFilterList.push(item);
          }
        }
      }
    });
    return needRequestFilterList;
  });

  useEffect(() => {
    if (!isArrayNotEmpty(_bindFilter)) {
      return;
    }
    function onFilterOnSearchFun(item: any) {
      const { componentProps } = item || {};
      const { _nodeId } = componentProps || {};
      if (_nodeId && _bindFilter.indexOf(_nodeId) !== -1) {
        sendRequest?.();
      }
    }
    function onFilterDefaultValueFinished(item: any) {
      const { componentProps } = item || {};
      const { _nodeId } = componentProps || {};

      setRequestFinishedFilter((oldFilter) => {
        if (oldFilter?.indexOf(_nodeId) !== -1) {
          return oldFilter?.filter?.((item2) => item2 !== _nodeId);
        } else {
          return oldFilter;
        }
      });
    }

    onEvent(CnFilterOnSearch, onFilterOnSearchFun);
    onEvent(CnFilterDefaultValueFinished, onFilterDefaultValueFinished);
    return () => {
      offEvent(CnFilterOnSearch, onFilterOnSearchFun);
      offEvent(CnFilterDefaultValueFinished, onFilterDefaultValueFinished);
    };
  }, []);

  useEffect(() => {
    if (requestFinishedFilter?.length === 0) {
      sendRequest?.();
    }
  }, [requestFinishedFilter]);
}
